import EnterpriseZone from '../../../../components/customer/enterprises/enterprise/EnterpriseZone'

const AEACustomerEnterprise = () => {
    return <EnterpriseZone />
}

export default AEACustomerEnterprise
